import React from "react";
import "../styles/stats.scss";

export default function Stats() {
  return (
    <div>
      <div className="main-container stats">
        <div className="stat-box">
          <p>245+</p>
          <span>zadovoljnih klijenata</span>
        </div>
        <div className="stat-box">
          <p>10</p>
          <span>godina iskustva</span>
        </div>
        <div className="stat-box">
          <p>5000+</p>
          <span>izradjenih unofirmi</span>
        </div>
        <div className="stat-box">
          <p>20+</p>
          <span>vrsta uniformi</span>
        </div>
      </div>
    </div>
  );
}
